export default {
  name: 'informations_manual_domiciliation_amount',
  component_path: 'modules/procedures/blocks/informations/BlockManualDomiciliationAmount',
  static_mandatory: ['minAmount:50', 'numeric']
}